import { Api } from "@/core/api.js";
import i18n from "@/i18n";
const api = new Api();

// initial state
const state = {
  list: [],
  actives: [],
  status_entities: [],
  current_event: {},
  event_types: [],
  total_list: 0,
  pagination: { num_page: 0, num_items: 20 },
  current_filters: {}
};

// getters
const getters = {
  getList: (state, getters, rootState) => id => {
    // console.log("getList", state.list);
    if (typeof id !== "undefined") return state.list[id];
    var aEvents = [];
    for (var i in state.list) {
      var event = Object.assign({}, state.list[i]);
      if (Object.keys(event).length > 0) {
        event.logo = {
          color: state.event_types[event.event_type]
            ? state.event_types[event.event_type].color
            : "#ccc",
          logo: event.logo
        };
        if (state.list[i].visible) aEvents.push(event);
      }
    }
    return aEvents;
  },

  getTotalList: (state, getters, rootState) => () => {
    return state.total_list;
  },

  getEventByID: (state, getters, rootState) => id => {
    return state.list[id];
  },

  getListNoFiltered: (state, getters, rootState) => () => {
    var aEvents = [];
    for (var i in state.list) {
      aEvents.push(state.list[i]);
    }
    return aEvents;
  },

  getActives: (state, getters, rootState) => () => {
    return state.actives;
  },

  get_by_url: (state, getters, rootState) => url => {
    // console.log( url );
    for (var i in state.list) {
      if (
        (
          state.list[i].name + state.list[i].edition.substring(2)
        ).toLowerCase() == url
      )
        return state.list[i];
    }
    for (var i in state.actives) {
      if (
        (
          state.actives[i].name + state.actives[i].edition.substring(2)
        ).toLowerCase() == url
      )
        return state.actives[i];
    }

    return false;
  },

  getEventEditions: (state, getters, rootState) => () => {
    var aEvents = [];
    for (var i in state.list) {
      var event = Object.assign({}, state.list[i]);
      event.name = event.name + " " + event.edition;
      aEvents.push(event);
    }
    return aEvents;
  },

  getCurrentEvent: (state, getters, rootState) => () => {
    return state.current_event;
  },

  getEventType: (state, getters, rootState) => () => {
    return state.event_types;
  },

  getStatusEntities: (state, getter, rootState) => params => {
    var aStatus = [];
    if (typeof params !== "undefined" && typeof params.entity !== "undefined") {
      // console.log( params.entity );
      for (var k in state.status_entities) {
        var status = state.status_entities[k];
        if (status.entity == params.entity) {
          aStatus.push(status);
        }
      }
    }

    return aStatus;
  },

  getStatusEntityByID: (state, getter, rootState) => id => {
    //   console.log( "getStatusEntityByID - " + id );
    //   console.log( state.status_entities );
    return state.status_entities[id];
  },

  getCategoriesEventSelected: (state, getter, rootState) => () => {
    var aCategories = [];
    for (var k in state.current_event.categories) {
      aCategories.push({
        id: state.current_event.categories[k].id,
        name: state.current_event.categories[k].max_age
      });
    }
    return aCategories;
  },

  getCampusEventSelected: (state, getter, rootState) => () => {
    var aCampus = [];
    for (var k in state.current_event.campus) {
      aCampus.push({
        id: state.current_event.campus[k].id,
        name:
          i18n.t(state.current_event.campus[k].name) +
          " " +
          moment(state.current_event.campus[k].start_date).format(
            "DD/MM/YYYY"
          ) +
          " - " +
          moment(state.current_event.campus[k].end_date).format("DD/MM/YYYY")
      });
    }
    return aCampus;
  },

  getCampusNameEventSelected: (state, getter, rootState) => () => {
    var aCampus = [];
    for (var k in state.current_event.campus_types) {
      let name = state.current_event.campus_types[k].name;
      if (state.current_event.type_id == 12) {
        name = name.split(".");
        name = name[0] + "." + name[1] + "." + name[2] + "_" + name[3];
      }

      aCampus.push({
        id: state.current_event.campus_types[k].id,
        name: i18n.t(name)
      });
    }
    return aCampus;
  },

  getCampusDatesEventSelected: (state, getter, rootState) => () => {
    var aCampus = [];
    for (var k in state.current_event.campus) {
      //   aCampus.push({
      //     id: state.current_event.campus[ k ].id,
      //     name: moment(state.current_event.campus[ k ].start_date).format('DD/MM/YYYY') + ' - ' + moment(state.current_event.campus[ k ].end_date).format('DD/MM/YYYY')
      //   })
      if (
        aCampus[
          moment(state.current_event.campus[k].start_date).format(
            "DD/MM/YYYY"
          ) +
            " - " +
            moment(state.current_event.campus[k].end_date).format("DD/MM/YYYY")
        ] == undefined
      ) {
        aCampus[
          moment(state.current_event.campus[k].start_date).format(
            "DD/MM/YYYY"
          ) +
            " - " +
            moment(state.current_event.campus[k].end_date).format("DD/MM/YYYY")
        ] = {
          id:
            moment(state.current_event.campus[k].start_date).format(
              "DD/MM/YYYY"
            ) +
            " - " +
            moment(state.current_event.campus[k].end_date).format("DD/MM/YYYY"),
          name:
            moment(state.current_event.campus[k].start_date).format(
              "DD/MM/YYYY"
            ) +
            " - " +
            moment(state.current_event.campus[k].end_date).format("DD/MM/YYYY")
        };
      }
    }
    return aCampus;
  },

  getEditions: (state, getter, rootState) => () => {
    return [
      { id: "2022", name: "2022" },
      { id: "2021", name: "2021" },
      { id: "2020", name: "2020" }
    ];
  }
};

// actions
const actions = {
  loadList({ commit, state }, params) {
    // console.log("loadList() with params - " + params);

    var path = "event";
    var page_options =
      params && params.page_options ? params.page_options : state.pagination;
    var filters =
      params && params.filters ? params.filters : state.current_filters;
    var oParams = Object.assign(filters ? filters : {}, page_options);

    return api.post(path, oParams).then(function(response) {
      if (response.status) {
        var data = response.data.data;
        for (var i in data) {
          data[i].visible = true;
          data[i].is_campus = parseInt(data[i].is_campus);
        }

        commit("setList", { data: data, total: response.data.total });
        return commit("setPagination", page_options);
      }
    });
  },

  loadActives({ commit }) {
    // console.log("loadCategories() with type - "+ type);

    var path = "event/status/1";
    return api.get(path).then(function(response) {
      if (response.status) {
        var data = response.data;
        for (var i in data) {
          data[i].visible = true;
          data[i].is_campus = parseInt(data[i].is_campus);
        }

        return commit("setEventsActive", data);
      }
    });
  },

  loadByName({ commit }, eventName) {
    var path = "event/name/" + eventName;
    // console.log( "--- LOAD BY NAME ---" );
    return api.get(path).then(function(response) {
      if (response.status) {
        var data = response.data;
        data.main_actions = data.main_actions == "1";
        data.credentials = data.credentials == "1";
        data.transfers = data.transfers == "1";
        data.insurance = data.insurance == "1";
        data.limit_participants = parseInt(data.limit_participants);
        data.visible = true;
        data.is_campus = parseInt(data.is_campus);
        data.deadlines = data.deadlines ? data.deadlines : [];

        return commit("setCurrentEvent", data);
      }
    });
  },

  update_settings(context, params) {
    let current_event = context.state.current_event;
    return api
      .post("event/" + current_event.id + "/update/settings", params)
      .then(response => {
        if (response.status) {
          var data = response.data;
          data.main_actions = data.main_actions == "1";
          data.credentials = data.credentials == "1";
          data.transfers = data.transfers == "1";
          data.insurance = data.insurance == "1";
          data.limit_participants = parseInt(data.limit_participants);
          data.visible = true;
          data.is_campus = parseInt(data.is_campus);
          data.deadlines = data.deadlines ? data.deadlines : [];

          return context.commit("setCurrentEvent", data);
        }
      });
  }
};

// mutations
const mutations = {
  setList(state, data) {
    state.list = data.data;
    state.total_list = data.total;
  },

  addEvent(state, event) {
    var list = { ...state.list };
    list[event.id] = event;

    state.list = list;
  },

  setCurrentEvent(state, event) {
    state.current_event = event;
    var list = { ...state.list };
    list[event.id] = event;

    state.list = list;
  },

  applyFilters(state, filters) {
    state.current_filters = filters;
    // var list = { ...state.list };
    // if (!filters) {
    //   for (var i in list) {
    //     list[i].visible = true;
    //   }
    // } else {
    //   for (var i in list) {
    //     list[i].visible = false;
    //   }
    //   for (var i in list) {
    //     var item = list[i];
    //     // console.log( " ---- ITEM " + item.name + " --- " );
    //     var bFound = true;
    //     for (var k in filters) {
    //       var item_value = typeof item[k] === "object" ? item[k].id : item[k];
    //       // console.log( "ITEM: " + item[k] + " - FILTER: " + filters[k] );
    //       if (item.hasOwnProperty(k) && filters[k] != item_value) {
    //         bFound = false;
    //       }
    //     }

    //     list[i].visible = bFound;
    //   }
    // }

    // state.list = list;
  },

  setEventsActive(state, events) {
    state.actives = events;
  },

  setPagination(state, value) {
    state.pagination = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
